import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { NotificationInterface } from '../../store/mine_craft/notificationsSlice';
import {uniq} from "../../helpers/ArrayHelpers";

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.notificationPath(value.id)
  };
}

export const notificationsEntity = new schema.Entity(
  'notifications',
  {},
  {
    processStrategy
  }
);

export const notificationEntity = new schema.Entity(
  'notification',
  {},
  {
    processStrategy
  }
);

const fetchNotificationsCollection = async (url: string, params: object = {}) => {
  const response    = await mineCraftApi.get(url, { params })
  const normalized  = normalize<
    any,
    {
      notifications: { [key: string]: NotificationInterface };
    }
  >(response.data.notifications, [notificationsEntity]);

  return {
    notifications: normalized.entities?.notifications || {},
    ids: uniq(normalized.result),
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      notification: NotificationInterface;
    }
  >(response.data.notification, notificationEntity);
  return normalized.entities;
}

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async (params: object = {}) => fetchNotificationsCollection('/onesky/notifications', params)
);

export const fetchNotification = createAsyncThunk(
  'notifications/fetchNotification',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/notifications/${id}`);
    return normalizeInstance(response);
  }
);

export const updateNotification = createAsyncThunk(
  'notifications/updateNotification',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/notifications/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyNotification = createAsyncThunk(
  'notifications/destroyNotification',
  async (id: number) => {
    const response = await mineCraftApi.delete(`/onesky/notifications/${id}`);
    return response.data;
  }
);
